import { Icon } from './Icon';

interface NumStepProps {
  value: number;
  min?: number;
  max?: number;
  onChange: (next: number) => void;
  disabled?: boolean;
}

/** Inline `± value` stepper. Used in Settings for the auto-confirm threshold. */
export function NumStep({ value, min = 1, max = 20, onChange, disabled = false }: NumStepProps) {
  const set = (v: number) => onChange(Math.max(min, Math.min(max, v)));
  return (
    <span
      className="numstep"
      style={disabled ? { opacity: 0.4, pointerEvents: 'none' } : undefined}
    >
      <button type="button" onClick={() => set(value - 1)} aria-label="Decrease">
        <Icon name="minus" size={12} />
      </button>
      <span className="nv tnum" aria-live="polite">
        {value}
      </span>
      <button type="button" onClick={() => set(value + 1)} aria-label="Increase">
        <Icon name="plus" size={12} />
      </button>
    </span>
  );
}
